import { app } from '../../../../../app';
import { Controller } from './epm-credentials.controller';

app.component('companyManageApplicationUsersEpmCredentials', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./epm-credentials.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/epm-credentials/epm-credentials.component.js